export const messages = {
  page: {
    title: {
      id: 'testResults.Page.Title',
      defaultMessage: 'Test Results',
    },
    initialStateMessage: {
      id: 'testResults.Page.InitialStateMessage',
      defaultMessage: 'Select an item from the list on the left.',
    },
    zeroStateMessage: {
      id: 'testResults.Page.ZeroStateMessage',
      defaultMessage: 'No items to display',
    },
    dateCollected: {
      id: 'testResults.Page.DateCollected',
      defaultMessage: 'Date Collected: ',
    },
    orderedBy: {
      id: 'testResults.Page.OrderedBy',
      defaultMessage: 'Ordered by: ',
    },
    lab: {
      id: 'testResults.Page.Lab',
      defaultMessage: 'Lab: ',
    },
    remarks: {
      id: 'testResults.Page.Remarks',
      defaultMessage: 'Remarks: ',
    },
    backButton: {
      id: 'testResults.Page.BackButton',
      defaultMessage: 'Back to Test Results',
    },
  },
  listPanel: {
    title: {
      id: 'testResults.ListPanel.Title',
      defaultMessage: 'Test Procedure',
    },
    emptyMessage: {
      id: 'testResults.ListPanel.EmptyMessage',
      defaultMessage: 'No test results are available.',
    },
  },
  descriptionPanel: {
    print: {
      id: 'testResults.DescriptionPanel.Print',
      defaultMessage: 'Print',
    },
  },
  filter: {
    allDates: {
      id: 'testResults.Filter.AllDates',
      defaultMessage: 'All',
    },
    last3months: {
      id: 'testResults.Filter.Last3Months',
      defaultMessage: 'Last 3 months',
    },
    last6months: {
      id: 'testResults.Filter.Last6Months',
      defaultMessage: 'Last 6 months',
    },
    last9months: {
      id: 'testResults.Filter.Last9Months',
      defaultMessage: 'Last 9 months',
    },
    allCareProviders: {
      id: 'testResults.Filter.AllCareProviders',
      defaultMessage: 'All care providers',
    },
    allProcedures: {
      id: 'testResults.Filter.AllProcedures',
      defaultMessage: 'All test procedures',
    },
    testProcedure: {
      id: 'testResults.Filter.TestProcedure',
      defaultMessage: 'Test Procedure',
    },
    testResults: {
      id: 'testResults.Filter.TestResults',
      defaultMessage: 'test results',
    },
    orderedBy: {
      id: 'testResults.Filter.OrderedBy',
      defaultMessage: 'Ordered By',
    },
  },
  tableColumns: {
    test: {
      id: 'testResults.TableColumns.Test',
      defaultMessage: 'Test',
    },
    result: {
      id: 'testResults.TableColumns.Result',
      defaultMessage: 'Result',
    },
    units: {
      id: 'testResults.TableColumns.Units',
      defaultMessage: 'Units',
    },
    referencesRange: {
      id: 'testResults.TableColumns.ReferenceRange',
      defaultMessage: 'Reference Range',
    },
    flag: {
      id: 'testResults.TableColumns.Flag',
      defaultMessage: 'Flag',
    },
    status: {
      id: 'testResults.TableColumns.Status',
      defaultMessage: 'Status',
    },
    comment: {
      id: 'testResults.TableColumns.Comment',
      defaultMessage: 'Comment',
    },
  },
};
